import React, { useEffect, useState, useRef } from "react";
import { fetchWithAuth, logout } from "./services/authService";
import Sidebar from "./Sidebar";
import "./Dashboard.css";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const professionChartRef = useRef(null);
  const qrGenerationChartRef = useRef(null);
  const adoptionRateChartRef = useRef(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetchWithAuth(process.env.REACT_APP_USER_URI);
        const data = await response.json();
        setUser(data.user);
      } catch (error) {
        console.error('Erro ao recuperar dados do usuário:', error.message);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const initializeCharts = () => {
      // Gráfico de Profissões
      const professionCtx = document.getElementById("professionChart");
      if (professionCtx && professionChartRef.current === null) {
        professionChartRef.current = new Chart(professionCtx, {
          type: "pie",
          data: {
            labels: ["Enfermeiros", "Parteiras", "Técnicos de Saúde"],
            datasets: [{
              data: [45, 30, 25],
              backgroundColor: ["#4a90e2", "#50e3c2", "#f5a623"],
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }

      // Gráfico de Geração de QR
      const qrGenerationCtx = document.getElementById("qrGenerationChart");
      if (qrGenerationCtx && qrGenerationChartRef.current === null) {
        qrGenerationChartRef.current = new Chart(qrGenerationCtx, {
          type: "line",
          data: {
            labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun"],
            datasets: [{
              label: "QR Codes Gerados",
              data: [65, 59, 80, 81, 56, 55],
              borderColor: "#4a90e2",
              tension: 0.1,
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }

      // Gráfico de Taxa de Adoção
      const adoptionRateCtx = document.getElementById("adoptionRateChart");
      if (adoptionRateCtx && adoptionRateChartRef.current === null) {
        adoptionRateChartRef.current = new Chart(adoptionRateCtx, {
          type: "bar",
          data: {
            labels: ["Norte", "Sul", "Este", "Oeste", "Centro"],
            datasets: [{
              label: "Taxa de Adoção (%)",
              data: [75, 68, 82, 79, 85],
              backgroundColor: "#50e3c2",
            }],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true,
                max: 100
              }
            }
          },
        });
      }
    };

    const timer = setTimeout(() => {
      initializeCharts();
    }, 100);

    return () => {
      clearTimeout(timer);
      [professionChartRef, qrGenerationChartRef, adoptionRateChartRef].forEach(chartRef => {
        if (chartRef.current) {
          chartRef.current.destroy();
          chartRef.current = null;
        }
      });
    };
  }, []);

  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  if (!user) return <div>Carregando...</div>;

  return (
    <div className="dashboard-container">
      <Sidebar onLogout={handleLogout} user={user} />
      
      <main className="main-content">
        <h1 className="section-title">Relatórios e Estatísticas</h1>
        
        <div className="report-grid">
          <div className="report-card">
            <h2>Distribuição por Profissão</h2>
            <div className="chart-container">
              <canvas id="professionChart"></canvas>
            </div>
          </div>
          
          <div className="report-card">
            <h2>Geração de QR Codes por Mês</h2>
            <div className="chart-container">
              <canvas id="qrGenerationChart"></canvas>
            </div>
          </div>
          
          <div className="report-card">
            <h2>Estatísticas Gerais</h2>
            <div className="stat-grid">
              <div className="stat-card">
                <div className="stat-value">1,245</div>
                <div className="stat-label">Total de QR Codes Gerados</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">98%</div>
                <div className="stat-label">Taxa de Validação</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">3,720</div>
                <div className="stat-label">Leituras este Mês</div>
              </div>
              <div className="stat-card">
                <div className="stat-value">15</div>
                <div className="stat-label">Novos Usuários Hoje</div>
              </div>
            </div>
          </div>
          
          <div className="report-card">
            <h2>Taxa de Adoção por Região</h2>
            <div className="chart-container">
              <canvas id="adoptionRateChart"></canvas>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;